// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.summary-table[data-v-3358b285] {\n    font-size: 1.2rem;\n}\n", ""]);
// Exports
module.exports = exports;
